import { render, staticRenderFns } from "./data70.vue?vue&type=template&id=2d5e551e&scoped=true&"
import script from "./data70.vue?vue&type=script&lang=js&"
export * from "./data70.vue?vue&type=script&lang=js&"
import style1 from "./data70.vue?vue&type=style&index=1&id=2d5e551e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e551e",
  null
  
)

export default component.exports